const _0 = "0"
const _DEFAULT = "1"
const config = { "0": _0, "DEFAULT": _DEFAULT,  }
export { config as default, _0, _DEFAULT }